export function dataTabel() {
  // Check if any table exists
  if (jQuery('.table').length > 0) {
		var lang_da_mod = {
			sProcessing: "Henter...",
			sLengthMenu: "Vis _MENU_ linjer",
			sZeroRecords: "Ingen linjer matcher søgningen",
			sInfo: "Viser _START_ til _END_ af _TOTAL_ linjer",
			sInfoEmpty: "Viser 0 til 0 af 0 linjer",
			sInfoFiltered: "(filtreret fra _MAX_ linjer)",
			sSearch: "Søg:",
			sUrl: "",
			oPaginate: {
				sFirst: "Første",
				sPrevious: "Forrige",
				sNext: "Næste",
				sLast: "Sidste"
			},
      aria: {
        // aria-sort already says how a column is sorted — no extra label text needed
        orderable: "",
        orderableReverse: "",
        sortAscending: "",
        sortDescending: "",
      }
		};

		// Iterate through each table
		jQuery('.table').each(function () {
			var table = jQuery(this);
			var id = table.attr("id"); // Ensure the table has an ID
			if (!id) {
				console.warn('Table is missing an ID and will not be initialized.');
				return; // Skip this table if no ID is found
			}

			var search = table.data('search');
			var searchfield = table.data('searchfield');

			var caption = table.data('caption');
			if (caption && table.find('caption').length === 0) {
				table.prepend(jQuery('<caption></caption>').text(caption));
			}
			// Configuration for tables with 'table--collapse' class
			if (table.hasClass('table--collapse')) {
				var entries = table.data('entries');
				var all = table.data('all');
				var lenghMenu = table.data('lengthmenu');
				var pagination = table.data('pagination');
				var info = table.data('info');
				lang_da_mod.sLengthMenu = '<select>' +
					'<option value="-1">' + all + '</option>' +
					'<option value="10" selected>10</option>' +
					'<option value="20">20</option>' +
					'<option value="30">30</option>' +
					'</select>';
				lang_da_mod.searchPlaceholder = search;
				lang_da_mod.sSearch = "";
        lang_da_mod.oPaginate.sFirst = "";
				lang_da_mod.oPaginate.sNext = "";
				lang_da_mod.oPaginate.sPrevious = "";
				lang_da_mod.oPaginate.sLast = "";
				lang_da_mod.searchfield = searchfield;
				// Set pagination based on the table data attribute
				lang_da_mod.sPaginationType = pagination ? "full_numbers" : "simple";

				// Initialize the collapsed table
				addTable(id, lang_da_mod, pagination); // Pass pagination flag to the addTable function
			} else {
				// Configuration for other tables
				entries = table.data('entries');
				lenghMenu = table.data('lengthmenu');
				pagination = table.data('pagination');
				info = table.data('info');

				lang_da_mod.sLengthMenu = lenghMenu;
				lang_da_mod.pagination = pagination;
				lang_da_mod.searchfield = searchfield;
				lang_da_mod.searchPlaceholder = search;
				lang_da_mod.sSearch = "";
				lang_da_mod.info = entries;
        lang_da_mod.oPaginate.sFirst = "";
				lang_da_mod.oPaginate.sNext = "";
				lang_da_mod.oPaginate.sPrevious = "";
				lang_da_mod.oPaginate.sLast = "";

				// Initialize the scrollable table
				addTableScrollable(id, lang_da_mod); // Call the addTableScrollable function for non-collapsed tables
			}
		});
  }
}

export function setupControlCellAria(id, expandLabelOverride) {
  var expandLabel = expandLabelOverride || jQuery('#' + id).data('expand-label') || 'Vis detaljer for';

  jQuery('#' + id + ' tbody tr:not(.child)').each(function() {
    var $row = jQuery(this);
    var $control = $row.find('td.control, th.control');
    if (!$control.length) return;

    // The first column can hold arbitrary rich text (heading, description, list, ...),
    // so .text() on the whole cell runs everything together. Use only its first child
    // element's text (typically the row's title) instead of the full cell content.
    var $firstCell = $row.find('td:not(.control), th:not(.control)').first();
    var $firstChild = $firstCell.children().first();
    var labelText = ($firstChild.length ? $firstChild.text() : $firstCell.text())
      .trim()
      .replace(/\s+/g, ' ');
    if (labelText.length > 80) labelText = labelText.substring(0, 80) + '…';

    var ariaLabel = labelText ? (expandLabel + ' ' + labelText) : 'Vis detaljer';
    var $button = $control.find('> button.control-toggle');
    if ($button.length === 0) {
      $button = jQuery('<button type="button" class="control-toggle"></button>');
      $control.empty().append($button);
      $button.on('keydown.controlToggle', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
        }
      });
    }
    $button.attr({
      'aria-expanded': $row.hasClass('parent') ? 'true' : 'false',
      'aria-label': ariaLabel
    });
  });
}

export function setupSortableHeaderRole(id) {

  // Sort toggle is a real <button> now (th keeps its native columnheader role),
  // so DataTables' own tabindex/Enter handling on the <th> itself is redundant —
  // stop the keydown there before it reaches DataTables and double-fires the sort.
  jQuery('#' + id + ' thead th.sorting button.th-sort-toggle, #' + id + ' thead th.sorting_asc button.th-sort-toggle, #' + id + ' thead th.sorting_desc button.th-sort-toggle')
    .off('keydown.thSortToggle')
    .on('keydown.thSortToggle', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.stopPropagation();
      }
    });
}

// DataTables puts tabindex on sortable <th>s and Responsive on the control cells (again on
// every draw). Where the cell holds a real <button>, the button is the tab stop, so the cell
// must not be one too. Runs after DataTables' and Responsive's own draw handlers.
export function removeCellTabStops(id) {
  var $table = jQuery('#' + id);
  var strip = function () {
    // The wrapper also holds the visible header clone that scrollX tables get
    var $scope = $table.closest('.dataTables_wrapper');
    ($scope.length ? $scope : $table).find('thead th, td.control, th.control').has('button').removeAttr('tabindex');
    // scrollX keeps an invisible copy of the header in the body; its buttons are no tab stops
    $scope.find('.dataTables_scrollBody thead button').attr('tabindex', '-1');
  };
  strip();
  $table.off('draw.cellTabStops responsive-resize.cellTabStops')
    .on('draw.cellTabStops responsive-resize.cellTabStops', strip);
}

// Render the collapsed row's hidden columns as a <dl> instead of the default
// <li><span class="dtr-title">/<span class="dtr-data"> pair, so the title/value
// relationship is programmatically exposed (dt/dd) rather than by bold styling alone.
// The title is the header's text only: the header holds the sort <button>, which
// must not be copied into the row's content.
export function detailsRenderer(api, rowIdx, columns) {
  var data = columns
    .filter(function (col) {
      return col.hidden;
    })
    .map(function (col) {
      var title = jQuery('<div>').text(jQuery('<div>').html(col.title).text().trim()).html();
      var attrs = ' data-dtr-index="' + col.columnIndex + '" data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '"';
      return '<dt class="dtr-title"' + attrs + '>' + title + '</dt>' +
        '<dd class="dtr-data"' + attrs + '>' + col.data + '</dd>';
    })
    .join('');

  return data ? '<dl class="dtr-details">' + data + '</dl>' : false;
}

// Initialize DataTable for regular tables
function addTable(id, lang_da_mod, pagination) {
  jQuery('#' + id).DataTable({
    ordering: true,
    retrieve: true,
    "info": Boolean(lang_da_mod.info), // Explicitly cast to boolean
    searching: lang_da_mod.searchfield,
    "bLengthChange": lang_da_mod.lenghMenu,
    "bPaginate": pagination, // Use the pagination flag passed from the data attributes
    "sPaginationType": lang_da_mod.sPaginationType || "simple", // Use custom pagination type
    responsive: {
      details: {
        type: 'column',
        renderer: detailsRenderer
      }
    },
    columnDefs: [{
      className: 'control',
      orderable: false,
      targets: 0
    }],
    "language": lang_da_mod,
    initComplete: function() {
      setupControlCellAria(id);
      setupSortableHeaderRole(id);
      jQuery('.dataTables_paginate .first')
        .attr('aria-label', 'Første')
        .attr('title', 'Første');
      jQuery('.dataTables_paginate .previous')
        .attr('aria-label', 'Forrige')
        .attr('title', 'Forrige');
      jQuery('.dataTables_paginate .next')
        .attr('aria-label', 'Næste')
        .attr('title', 'Næste');
      jQuery('.dataTables_paginate .last')
        .attr('aria-label', 'Sidste')
        .attr('title', 'Sidste');
    },
    drawCallback: function(settings) {
      setupControlCellAria(id);
      setupSortableHeaderRole(id);
      jQuery('.dataTables_paginate .first')
        .attr('aria-label', 'Første')
        .attr('title', 'Første');
      jQuery('.dataTables_paginate .previous')
        .attr('aria-label', 'Forrige')
        .attr('title', 'Forrige');
      jQuery('.dataTables_paginate .next')
        .attr('aria-label', 'Næste')
        .attr('title', 'Næste');
      jQuery('.dataTables_paginate .last')
        .attr('aria-label', 'Sidste')
        .attr('title', 'Sidste');
    }
  });

  removeCellTabStops(id);

  jQuery('#' + id).on('responsive-display.dt', function(e, datatable, row, showHide) {
    jQuery(row.node()).find('td.control button.control-toggle, th.control button.control-toggle')
      .attr('aria-expanded', showHide ? 'true' : 'false');
  });

  removeTabIndexFromHiddenTables();

  setTimeout(function () {
    jQuery('.table').css('opacity', 1);
    jQuery('.dataTables_wrapper').css('opacity', 1);
    jQuery('.dataTables_wrapper input').prop('required', true);
    jQuery('.dataTables_wrapper input').parent('label').attr('aria-label', 'Søg i tabel');
  }, 100);
}

// Initialize DataTable for scrollable tables (with fixed columns)
function addTableScrollable(id, lang_da_mod) {
  let resizeTimeout;
  jQuery(window).on("load resize", function () { // Mobile responsiveness
		var table = jQuery('#' + id); // Ensure we're using the correct table ID

		if (table.length === 0) {
			console.error('Table with id ' + id + ' not found.');
			return; // Skip if table doesn't exist
		}
    // Ensure the table is wrapped inside a div with class 'table--scrollable-container'
    if (!table.parent().hasClass('table--scrollable-container')) {
      table.wrap('<div class="table--scrollable-container"></div>');
      // Keyboard users must be able to scroll it, so it is a focusable, named region
      var regionName = table.find('caption').first().text().trim() || table.data('caption') || 'Tabel';
      table.parent().attr({ tabindex: '0', role: 'region', 'aria-label': regionName });
    }
  });

  jQuery('#' + id).DataTable({
		ordering: true,
		retrieve: true,
		"info": lang_da_mod.info,
		searching: lang_da_mod.searchfield,
		"bLengthChange": lang_da_mod.lenghMenu,
		"bPaginate": lang_da_mod.pagination,
		fixedColumns: true,
		"language": lang_da_mod,
/* 		scrollX: true, */
		scrollCollapse: true,
		initComplete: function () {
			// Add ARIA attributes for accessibility
			const tableId = '#' + id;
			const headTable = jQuery(tableId).closest('.dataTables_scroll').find('.dataTables_scrollHead table');
			const bodyTable = jQuery(tableId).closest('.dataTables_scroll').find('.dataTables_scrollBody table');

			// Associate header table with body table
			headTable.attr('aria-hidden', true); // Indicate that it's not a separate table

			// Remove roles from `thead`, `tbody`, and `tfoot` (if added by DataTables)
			headTable.find('thead, tbody, tfoot').removeAttr('role');
			bodyTable.find('thead, tbody, tfoot').removeAttr('role');

			headTable.removeAttr('role');
			bodyTable.removeAttr('role');

			// Remove roles from rows (`role="row"`) and cells (`role="cell"`)
			bodyTable.find('tr, td, th').removeAttr('role');
			headTable.find('tr, td, th').removeAttr('role');

      // Adjust tabindex for non-interactive elements inside scrollable body
      bodyTable.find('td').each(function () {
        // If there's no interactive element (link, button, input), set tabindex="-1"
        jQuery(this).removeAttr('tabindex');
      });

      setupSortableHeaderRole(id);
		},
		drawCallback: function () {
			setupSortableHeaderRole(id);
		}
  });
  removeCellTabStops(id);
  removeTabIndexFromHiddenTables();

  setTimeout(function () {
		jQuery('.table').css('opacity', 1);
		jQuery('.dataTables_wrapper').css('opacity', 1);
		jQuery('.dataTables_wrapper input').prop('required', true);
		jQuery('.dataTables_wrapper input').parent('label').attr('aria-label', 'Søg i tabel');

  }, 100);
}

function removeTabIndexFromHiddenTables() {
  jQuery('table[aria-hidden="true"]').each(function () {
    jQuery(this).find('[tabindex]').removeAttr('tabindex');
  });
}

export default dataTabel;
